//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {}
  }
}



// WEBPACK FOOTER //
// ./src/components/LandingPageFooterDouble.vue